import { render, staticRenderFns } from "./ThreeTabsPage.vue?vue&type=template&id=0ec63eb8"
import script from "./ThreeTabsPage.vue?vue&type=script&lang=js"
export * from "./ThreeTabsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports